import React from "react";

/**
 * The hand-drawn inline SVGs from marketing's Lion’s Pride page, kept as
 * authored (stroke widths vary per use, and a few glyphs — calendar, shield,
 * award, crown — aren't in CpIcon).
 */
type SvgProps = React.SVGProps<SVGSVGElement>;

const base = (strokeWidth: number): SvgProps => ({
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
});

export const CheckIcon: React.FC<{ strokeWidth?: number }> = ({
  strokeWidth = 3.5,
}) => (
  <svg {...base(strokeWidth)}>
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const PlusIcon: React.FC = () => (
  <svg {...base(3)}>
    <line x1="12" x2="12" y1="5" y2="19" />
    <line x1="5" x2="19" y1="12" y2="12" />
  </svg>
);

export const CalendarIcon: React.FC = () => (
  <svg {...base(2)}>
    <rect height="18" rx="2" width="18" x="3" y="4" />
    <line x1="16" x2="16" y1="2" y2="6" />
    <line x1="8" x2="8" y1="2" y2="6" />
    <line x1="3" x2="21" y1="10" y2="10" />
  </svg>
);

export const CalendarCheckIcon: React.FC = () => (
  <svg {...base(2)}>
    <rect height="18" rx="2" width="18" x="3" y="4" />
    <line x1="16" x2="16" y1="2" y2="6" />
    <line x1="8" x2="8" y1="2" y2="6" />
    <line x1="3" x2="21" y1="10" y2="10" />
    <path d="M9 16l2 2 4-4" />
  </svg>
);

export const ShieldIcon: React.FC<{ strokeWidth?: number }> = ({
  strokeWidth = 2,
}) => (
  <svg {...base(strokeWidth)}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

export const UsersIcon: React.FC = () => (
  <svg {...base(2)}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

export const UserIcon: React.FC = () => (
  <svg {...base(2)}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

export const BookOpenIcon: React.FC = () => (
  <svg {...base(2)}>
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
  </svg>
);

export const AwardIcon: React.FC = () => (
  <svg {...base(2)}>
    <circle cx="12" cy="8" r="6" />
    <path d="M15.48 12.89 17 22l-5-3-5 3 1.52-9.11" />
  </svg>
);

export const ChevronDownIcon: React.FC = () => (
  <svg {...base(2.4)}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export const CrownIcon: React.FC = () => (
  <svg {...base(1.8)}>
    <path d="M2 20h20" />
    <path d="M4 20V10l4 3 4-7 4 7 4-3v10" />
  </svg>
);
